window.activateAbRAB011 = () => {
	document.documentElement.setAttribute('data-ab-rab-011', '');

	if (window.__bsAbRab011) return;
	window.__bsAbRab011 = true;

	document.addEventListener('click', (event) => {
		if (!event.target.closest('.bs-ab-rab-011-continue-shopping')) return;

		event.preventDefault();
		document.querySelector('cart-drawer')?.close();
	});
};

//document.addEventListener('DOMContentLoaded', () => {
//    window.activateAbRAB011();
//});